<div class="error-box-wrapper">
  <img src="/assets/icons/form-error.svg" alt="Error Icon" />
  <div class="error-text-container">
    <h5><ng-content></ng-content></h5>
    <h5>
      Please
      <a class="error-block-link" routerLink="/contact-us/form">contact us</a>
      for assistance if you require.
    </h5>
  </div>
</div>
